import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IcoStar, Select } from '../../../components'
import './indicadores.scss'
import Filter from './filter/filter'
import Grafico from './grafico'
import { setInfoEmpresa, setInfoGrupo, setProjeto } from '../../../layout/redux/layoutActions'
import { carregarGrafico, filterHandle } from './redux/indicadoresActions'
import { history } from "../../../helpers/history"
import Video from '../../videos/video'
import CriarDashboardButton from '../../dashboard/criardashboardbutton'
import { modalOpen } from '../../../layout/redux/layoutActions'
import Criar from '../../dashboard/criar'


export default () => {
  const dispatch = useDispatch()
  const { grupos, grupo, filters, empresas, empresa, sistema } = useSelector(state=> state.layoutState)
  const { projeto, projetos, totalAvaliacao, filtersProvisorio } = useSelector(state=> state.indicadoresState)

  const nls = require(`../indicadores/nls/${sistema.idioma}.json`) 

  //USADO CASO O USUÁRIO DER REFRESH NA PÁGINA
  useEffect(() => {
  const wasRefreshed = sessionStorage.getItem('wasRefreshed')
  
  if (wasRefreshed === 'true' && projeto && projeto.id) {
    sessionStorage.removeItem('wasRefreshed')
    dispatch(setProjeto(projeto)) // ← Isso já dispara toda a cadeia!
  }

  const handleBeforeUnload = () => {
    sessionStorage.setItem('wasRefreshed', 'true')
  }
  
  window.addEventListener('beforeunload', handleBeforeUnload)
  return () => window.removeEventListener('beforeunload', handleBeforeUnload)
}, [projeto, dispatch])



  useEffect(()=> {
    if (projeto?.id) {
      dispatch(filterHandle({projetoID: projeto.id, empresaId: empresa.empresaId, grupo, params: filters, typeSelect: filters.typeSelect, filtersProvisorio, todascategoriasprojeto: nls.todascategoriasprojeto, idioma: sistema.idiomaIdValue}))
    }
  }, [projeto, grupo, sistema.idiomaIdValue])

  const handleFormProjeto = (e) => {
    dispatch(setProjeto(e.value))
    history.push(`/myprojects/${e.value.id}/companyindicators`)
  }
  const handleGrupo = (e) => {
    dispatch(setInfoGrupo(e.value))
  }

  const handleFormFilterEmpresa = (e) => {
    dispatch(setInfoEmpresa(e.value))
  }

  const handleAbrirCriarDashboard = () => {
  dispatch(modalOpen('criar'))
}


  return (
    <div className='box-indicadores' data-cy='page-storeindicators'>
      <div className='box-indicadores-topinfo'>
        <div>
          <div className='box-indicadores-topinfo-select'>
            <Select 
  name='projeto'
  cy='filter-project'
  label={nls.projeto}
              options={projetos}
              selected={projeto}
              action={(e)=> handleFormProjeto(e)}
              selectedItem={false}
              optionLabel='nomeProjeto'
              optionValue='id'
            />
          </div>
          
          {/*TIREI EMPRESA DA VERSÃO ANTERIOR: NÃO ERA USADO*/}

          {grupos && Array.isArray(grupos) && grupos.length > 0 && (
          <div className='box-indicadores-topinfo-select'>
            <Select 
  name='grupo'
  cy='filter-group'
  label={nls.grupo}
              options={grupos}
              selected={grupo}
              action={(e)=> handleGrupo(e)}
              selectedItem={false}
            />
          </div>
        )}

        </div>
        <div className='box-indicadores-topinfo-avaliacao'>
            <label>{nls.numerodeavaliacoes}</label>
            <IcoStar />
            <strong data-cy='feedback-count'>{totalAvaliacao?totalAvaliacao:0}</strong>
        </div>
      </div>
      <Filter />

      <div className="box-comentarios-video">
        <Video videoName="video2" cy="tutorial" />

        {projeto?.tipoProjetoId &&
        projeto.tipoProjetoId !== 2 &&
        filters?.ciclo &&
        filters.ciclo.anoMesCiclo && (
            <CriarDashboardButton
  cy="dashboard-create-open"
  onClick={handleAbrirCriarDashboard}
/>
        )}

      </div>

      {/* <span className='box-indicadores-infoindicadores'>Indicadores de fragilidade da concorrência: <strong>40</strong></span> */}
      <Grafico />
      
      <Criar />
      
    </div>
  )
}
